import React from "react";

const HistoryIcon = () => {
  return (
    <svg
      width="13"
      height="15"
      viewBox="0 0 13 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.875 11.875H4C3.65625 11.875 3.36198 11.7526 3.11719 11.5078C2.8724 11.263 2.75 10.9688 2.75 10.625V1.875C2.75 1.53125 2.8724 1.23698 3.11719 0.992188C3.36198 0.747396 3.65625 0.625 4 0.625H8.375L12.125 4.375V10.625C12.125 10.9688 12.0026 11.263 11.7578 11.5078C11.513 11.7526 11.2188 11.875 10.875 11.875ZM7.75 5V1.875H4V10.625H10.875V5H7.75ZM1.5 14.375C1.15625 14.375 0.861979 14.2526 0.617188 14.0078C0.372396 13.763 0.25 13.4688 0.25 13.125V4.375H1.5V13.125H8.375V14.375H1.5Z"
        fill="#03579E"
      />
    </svg>
  );
};

export default HistoryIcon;
